// extracted by css-extract-rspack-plugin
export default {"button":"Button_button__Eoju4","button--active":"Button_button--active__MUV4E"};